import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Alert from "@mui/material/Alert";
import { makeStyles } from "@mui/styles";
import MenuItem from "@mui/material/MenuItem";
import QRCode from "react-qr-code";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CopyAll } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useAlert } from "react-alert";
import { Rotate } from "tabler-icons-react";

const useStyles = makeStyles({
	alert: {
		"& .MuiAlert-message": {
			display: "flex",
			justifyContent: "space-between",
			width: "100%",
		},
	},
});

export default function QRCodePage({
	drawerWidth,
	goToNavigation,
	setGoToNavigation,
	setRun,
}) {
	const [color, setColor] = useState("");
	const classes = useStyles();
	const alert = useAlert();
	const navigate = useNavigate();
	const { t } = useTranslation();

	useEffect(() => {
		console.log("NOW ON QR");
		setRun(true);
	}, []);

	useEffect(() => {
		if (goToNavigation) {
			setGoToNavigation(false);
			navigate("/navigation");
		}
	}, [goToNavigation]);

	const fonts = ["Montserrat", "Roboto"];
	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />
			<Alert
				severity="info"
				sx={{
					marginBottom: 2,
				}}
				className={classes.alert}
				onClick={() => {
					navigate("/qr");
				}}
			>
				{t("qrCode.reconnect")}
				<br />
				<Box
					sx={{
						backgroundColor: "white",
						padding: 1,
						borderRadius: 1,
						width: 32,
						height: 32,
						borderBottom: "2px solid #ddd",
						marginLeft: 2,
					}}
				>
					<Rotate
						size={16}
						style={{ transform: "scaleX(-1)rotate(-180deg)" }}
					/>
				</Box>
			</Alert>
			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{ fontSize: 14 }}
							color="text.secondary"
							gutterBottom
						>
							{t("qrCode.qr")}
						</Typography>
						<QRCode
							id="qr"
							size={256}
							style={{
								height: "auto",
								maxWidth: 256,
								width: 256,
								display: "block",
								margin: "20px auto",
							}}
							value={localStorage.getItem("token")}
							viewBox={`0 0 256 256`}
						/>
						<FormControl
							fullWidth
							variant="standard"
							sx={{
								marginTop: 8,
								marginBottom: 2,
								maxWidth: 256,
								display: "block",
								marginLeft: "auto",
								marginRight: "auto",
								"& .MuiInputBase-root": {
									paddingRight: 0,
								},
							}}
						>
							<InputLabel
								shrink
								htmlFor="token"
								sx={{
									marginTop: -2,
									fontWeight: 700,
									textTransform: "uppercase",
									fontSize: 12,
								}}
							>
								{t("qrCode.code")}
							</InputLabel>
							<TextField
								id="token"
								fullWidth
								variant="outlined"
								value={localStorage.getItem("token")}
								InputProps={{
									readOnly: true,
									endAdornment: (
										<IconButton
											color="inherit"
											aria-label="delete image"
											edge="start"
											onClick={() => {
												navigator.clipboard.writeText(
													localStorage.getItem("token")
												);
												alert.show(t("qrCode.copied"), { type: "success" });
											}}
										>
											<CopyAll
												fontSize="12"
												//sx={{ color: "#ffffff" }}
											/>
										</IconButton>
									),
								}}
							/>
						</FormControl>
						<Box
							sx={{
								display: "flex",
								justifyContent: "center",
								marginTop: 6,
								maxWidth: 600,
								margin: "auto",
							}}
						>
							<Typography sx={{ fontSize: 14 }} gutterBottom>
								{t("qrCode.howItWorks")} <br /> <br />
								{t("qrCode.step1")}{" "}
								<a
									href="https://apps.apple.com/app/applaby/id6476827641"
									target="_blank"
									rel="noreferrer"
								>
									Apple Store
								</a>{" "}
								{t("qrCode.stepOr")}{" "}
								<a
									href="https://play.google.com/store/apps/details?id=com.applaby.creator"
									target="_blank"
									rel="noreferrer"
								>
									Google Play
								</a>{" "}
								<br /> <br />
								{t("qrCode.step2")} <br /> <br />
								{t("qrCode.step3")} <br /> <br />
								<small>
									{t("qrCode.note")} {t("qrCode.note2")}
									<a
										href={
											(window.location.hostname === "127.0.0.1"
												? "http://127.0.0.1:3001"
												: window.location.hostname === "localhost"
												? "http://localhost:3001"
												: "https://admin.applaby.com") +
											(localStorage.getItem("token")
												? "?session=" + localStorage.getItem("token")
												: "")
										}
									>
										{t("qrCode.admin")}
									</a>
								</small>
							</Typography>
						</Box>
					</CardContent>
				</>
			</Card>
		</Box>
	);
}
